import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import InputRadio from 'components/InputRadio'
import Label from 'components/Label'

import styles from './InputRadios.module.scss'

export default class InputRadios extends React.Component {
  static propTypes = {
    //checked: PropTypes.string,
    checked: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
    inputs: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      checked: props.checked || '',
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ checked: nextProps.checked || '' })
  }

  handleChange = (e) => {
    const { onChange } = this.props

    this.setState({ checked: e.target.value })

    if (onChange) onChange(e)
  }

  render() {
    const { className, inputs, name } = this.props
    const { checked } = this.state

    return (
      <div className={classNames('InputRadios', 'uk-form-controls', className)}>
        {inputs.map((input) => {
          const value = input.value || input.option

          return (
            <Label className={styles.label} key={value}>
              <InputRadio
                // eslint-disable-next-line eqeqeq
                checked={checked == value}
                name={name}
                value={value}
                onChange={this.handleChange}
              />
              {input.option}
            </Label>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InputRadios/InputRadios.js